module.exports = {"REACT_APP_MUNCHKIN_ACCT_ID":"623-DRR-128"}